import { React, useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Tabs, Button, Spin, message, Form, Input, InputNumber, Select } from 'antd';
import { useAuth } from "./AuthProvider";



import axios from 'axios';

const DetaliiConversatie = (p) => {
    const auth = useAuth();
    const [mesaje, setMesaje] = useState([]);


    useEffect(() => {
        if (p.id != "") {
            axios.post(auth.backend + "/admin/mesaje", { token: auth.token, id: p.id })
                .then(function (res) {
                    var r = res.data;

                    setMesaje(r);

                })
                .catch(function (r) {
                    message.warning("A aparut o eroare. Te rog sa incerci din nou!");
                });
        }
    }, [p.id]);

    return <>
        <div style={{ margin: 5, height: 'calc(100vh - 100px)' }}>
            <div style={{ display: 'flex', padding: "5px", flexDirection: 'column', boxSizing: "border-box", height: '100%', gap: '5px', overflowY: 'auto' }}>
                {mesaje.map(m => {
                    if (m.user.id == "4s")
                        return <div className="chatItemBoxLeft">

                            <div style={{ display: "inline" }}>
                                <div className="chatUser">{m.user.name}</div>
                                <div className="chatItem">
                                    {m.text}
                                </div>
                            </div>


                        </div>
                    else
                        return <div className="chatItemBoxRight ">
                            <div style={{ display: "inline" }}>
                                <div className="chatUser">{m.user.name}</div>
                                <div className="chatItem chatSourceUser">
                                    {m.text}
                                </div>
                            </div>
                        </div>
                })}



            </div>
        </div>
    </>
}

const Conversatii = () => {
    const auth = useAuth();
    const [list, setList] = useState(null);
    const [current, setCurrent] = useState('');

    useEffect(() => {
        if (!list)
            axios.post(auth.backend + "/admin/chats", { token: auth.token })
                .then(function (res) {
                    var r = res.data;

                    setList(r);

                })
                .catch(function (r) {
                    message.error("A aparut o eroare la trimiterea mesajului tau. Te rog sa incerci din nou!");
                });
    }, [])

    const onChange = (key) => {
        setCurrent(key);
    }

    if (!list)
        return <Spin />

    return <>
        <div style={{ "display": "flex", overflowY: "hidden", height: "90vh", }} >
            <div style={{ width: "20vw", overflowY: "scroll" }}>

                {list.map(l =>
                    <div className={current == l.id ? "convItem sel" : "convItem"} onClick={() => { setCurrent(l.id); }}>{l.nume} ({l.nrcui})<br />{l.data}</div>
                )}


            </div>



            <div style={{ "width": "100%", height: "100%", overflowY: "auto" }}>
                <DetaliiConversatie id={current} />
            </div>
        </div>
    </>

}

const Context = () => {
    const [formInstance] = Form.useForm();
    const auth = useAuth();
    const onSubmit = v => {
        v.token = auth.token;
        axios.post(auth.backend + "/admin/set", v)
            .then(function (res) {

                message.success("Modificari salvate");
            })
            .catch(function (r) {
                message.error("A aparut o eroare la salvare. Te rog sa incerci din nou!");
            });

    }


    useEffect(() => {

        axios.post(auth.backend + "/admin/get", { token: auth.token })
            .then(function (res) {

                formInstance.setFieldsValue(res.data);
            })
            .catch(function (r) {
                message.error("A aparut o eroare la salvare. Te rog sa incerci din nou!");
            });

    }, []);

    // initialValue={p.item ? p.item.denumire : ""}
    return <>
        <a target="_blank" href='https://platform.openai.com/docs/api-reference/chat/create'>https://platform.openai.com/docs/api-reference/chat/create</a>
        <br />
        <br />
        <Button type="primary" onClick={() => { formInstance.submit() }}>Salveaza modificarile</Button>

        <Form layout="vertical" form={formInstance} onFinish={onSubmit}>

            <Form.Item label="Model" name="model" rules={[{ required: true, message: 'Acest câmp este obligatoriu' }]}>
                <Select>
                    <Select.Option value="gpt-4o">gpt-4o</Select.Option>
                    <Select.Option value="gpt-4o-mini">gpt-4o-mini</Select.Option>
                    <Select.Option value="gpt-3.5-turbo">gpt-3.5-turbo</Select.Option>
                </Select>

            </Form.Item>

            <Form.Item label="Temperature [0.0 -> 2.0]" name="temperature" rules={[{ required: true, message: 'Acest câmp este obligatoriu' }]}><InputNumber /></Form.Item>

            <Form.Item label="Max_tokens per raspuns" name="maxtokens" rules={[{ required: true, message: 'Acest câmp este obligatoriu' }]}><InputNumber /></Form.Item>


            <Form.Item label="Context" name="context" rules={[{ required: true, message: 'Acest câmp este obligatoriu' }]}><Input.TextArea /></Form.Item>


        </Form>
    </>
}

const Admin = () => {
    const auth = useAuth();
    const [current, setCurrent] = useState('context');

    const tabs = [{
        key: 'context',
        label: 'Context initial',
    },
    {
        key: 'conversatii',
        label: 'Conversatii',
    }
    ];

    const onChange = (key) => {
        setCurrent(key);
    }

    if (!auth.sesiune.isAdmin)
        return <div>
            NoAdmin

        </div>

    return <div>
        <div style={{ float: "right" }}>
            <Button onClick={() => { auth.clear(); }}>Logout</Button>
        </div>

        <Tabs defaultActiveKey="context" items={tabs} onChange={onChange} />
        {current == "context" ? <Context /> : ""}
        {current == "conversatii" ? <Conversatii /> : ""}
    </div>
};

export default Admin;
